import { createContext } from 'react';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export interface ListPageContextValue {
  entityType: Entities;
}

export const ListPageContext = createContext<ListPageContextValue | null>(null);
